import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'facebookLoginButtonClientId',
  initialState: null as null | string,
  reducers: {
    setFacebookLoginButtonClientId(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setFacebookLoginButtonClientId } = slice.actions;

export default slice.reducer;
